// ErrorMsg.js
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import Swal from "sweetalert2";
import { resetErrAction } from "../../redux/slices/globalActions/globalActions";

const ErrorMsg = ({ message }) => {
  const dispatch = useDispatch();
  
  useEffect(() => {
    Swal.fire({
      icon: "error",
      title: "Error!",
      text: message,
      confirmButtonColor: "#d33",
      confirmButtonText: "OK"
    }).then(() => {
      dispatch(resetErrAction());
    });
  }, [dispatch, message]);
  
  return null;
};

export default ErrorMsg;